<template>
	<div>
		<h5 class="cn-font grey--text">Mitarbeiter</h5>
		<v-row>
			<v-col>
				<v-dialog width="400px" v-for="group in collabGroups" :key="group.id">
					<template v-slot:activator="{ on}">
						<v-chip class="mr-2 mt-2" color="accent" close v-on="on" @click:close="removeMember(group.id)">
							{{ group.name }}
						</v-chip>
					</template>
					<DisplayGroup :group="group"></DisplayGroup>
				</v-dialog>		
				<v-dialog width="400px" v-for="user in collabIndividualMembers" :key="user.id">
					<template v-slot:activator="{ on}">
						<v-chip class="mr-2 mt-2" color="accent" close v-on="on" @click:close="removeMember(user.id)">
							<v-avatar left>
								<v-img  v-if="user.profile_image" :src="user.profile_image"></v-img>
								<v-icon color="white" v-else>mdi-account-circle</v-icon>
							</v-avatar>
							{{ user.display_name }}
						</v-chip>
					</template>
					<DisplayUser :user="user"></DisplayUser>
				</v-dialog>	
			</v-col>
		</v-row>
	</div>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	import DisplayUser from "@/components/assessment/users/DisplayUser"
	import DisplayGroup from "@/components/assessment/groups/DisplayGroup"
	export default {
		name: "CollaborationParticipants", 
		props: {
			id: {type: String}
		},
		data: () => {
			return {
			}
		},
		components: {
			DisplayGroup,
			DisplayUser
		},
		computed: {
			...Vuex.mapState({
				collaborations: state => state.collaborations || [],
				groups: state => state.groups || [],
				users: state => state.users || []
			}),
			collaboration(){
				var id = this.id;
				return this.collaborations.find( c => c.id == id )
			},
			collabGroups(){
				var members = this.collaboration.members;
				return this.groups.filter( group => members.indexOf( group.id ) > -1  )
			},
			collabIndividualMembers(){
				var user_members = this.collaboration.members.filter ( id => this.collabGroups.map( group => group.id ).indexOf(id ) < 0 );
				return this.users.filter( u => user_members.indexOf(u.id) > -1 )
			},
		},
		methods: {
			removeMember(id){
				this.$store.dispatch( "collaborations/removeMember", {member_id: id, collab_id: this.id} )
			}
		}
		// created(){
			
		// }

	}
</script>